<div class="tournament-card" *ngIf="tournament" (click)="onTournamentClick(tournament)">
    <div class="tournament-card-header">
        <img
            width="32"
            height="32"
            class="border-radius-100 mr-2"
            [src]="tournament.url_avatar || tournament.avatar"
            alt="tournament.por"
        />
        <div>
            <h3 *ngIf="tournament.id_torneio">{{ tournament.nome_torneio }}</h3>
            <h3 *ngIf="tournament.id_evento">{{ tournament.descricao }}</h3>
            <ng-container *ngIf="tournament.id_torneio && tournament.grupo_pontos">
                <div class="tournament-ranking" *ngFor="let ranking of tournament.grupo_pontos?.ranking">
                    <span class="paragraph-2"
                        >{{ ranking.nome_ranking }}: <span *ngFor="let grupo of ranking.grupos">{{ grupo }}</span></span
                    >
                </div>
            </ng-container>
        </div>
    </div>
    <div class="tournament-card-body">
        <div class="period" *ngIf="tournament.descricao_tipo_evento">
            <strong>{{ "EVENTS.TYPE" | translate }}</strong>
            <span>{{ tournament.descricao_tipo_evento }}</span>
        </div>
        <div class="period">
            <strong class="d-block">{{ "TOURNAMENT.ENROLLMENT-PERIOD" | translate }}</strong>
            <!-- prettier-ignore -->
            <span>{{"GENERAL.UNTIL" | translate}} {{ tournament.hr_final_inscricoes}} {{"GENERAL.FROM" | translate}} {{ tournament.dt_final_insc}}</span>
        </div>
        <div class="period">
            <strong class="d-block">{{
                (isEvent ? "EVENTS.PERIOD" : "TOURNAMENT.TOURNAMENT-PERIOD") | translate
            }}</strong>
            <!-- prettier-ignore -->
            <span>{{"GENERAL.FROM" | translate}} {{ tournament.dt_inicio}} {{"GENERAL.TO" | translate}} {{ tournament.dt_final}}</span>
        </div>
    </div>
    <div class="tournament-card-footer">
        <div class="d-flex align-items-center">
            <nb-icon icon="pin-outline"></nb-icon>
            <!-- prettier-ignore -->
            <span>{{ tournament.cidade }} - {{ tournament.uf }}</span>
        </div>
        <div>
            <span class="mr-3" class="tournament-card-status">{{ tournament.descricao_situacao }}</span>
            <span class="tournament-card-status"
                >{{ "GENERAL.SUBSCRIBERS" | translate }}: {{ tournament.qtd_inscritos }}</span
            >
        </div>
    </div>
</div>
